<template>
  <div>
    <b-card class="shadow-lg px-0 px-sm-3 py-4 text-center">
      <h3 class="mb-5">
        Sélectionnez <strong>l'objet du rendez-vous</strong>
      </h3>
      <div>
      <b-button
        v-for="item in $root.slugData.actions"
        :key="item.value"
        variant="outline-primary"
        size="lg"
        class="mx-2 my-1"
        v-on:click="$emit('update', item.value)"
      >
        {{ item.text }}</b-button
      >
      </div>
    </b-card>
  </div>
</template>

<script>

export default {
  name: "AppointmentType",

  data() {
    return {
      action: null
    };
  },
};
</script>

<style lang="scss" scoped>
</style>
